import { isArray } from 'lodash';
import { composeFunnelbackSortParam } from '@organisms/SearchResults/formatSortOrder';
import isFacetSearchParam from '@templates/SearchForm/isFacetSearchParam';
import isRangeSearchParam from '@templates/SearchForm/isRangeSearchParam';
import isNumericSearchParam from '@templates/SearchForm/isNumericSearchParam';

export const fetchData = async ({ query = '!showall', params = {}, offset = 1, sort = { field: '', direction: 'none' }, config }) => {
  const { endpoint, collection, profile, perPage } = config;
  const url = new URL(endpoint);
  const fetchSearchParams = url.searchParams;

  fetchSearchParams.append('collection', collection);
  fetchSearchParams.append('profile', profile);
  fetchSearchParams.append('query', query);
  fetchSearchParams.append('num_ranks', (perPage || 10).toString());

  if (offset && !isNaN(offset)) {
    fetchSearchParams.append('start_rank', offset.toString());
  }

  const sortParamValue = composeFunnelbackSortParam(sort);
  if (sortParamValue) {
    fetchSearchParams.set('sort', sortParamValue);
  } else {
    fetchSearchParams.delete('sort');
  }

  // Set Funnelback facet URL search params
  Object.entries(params).forEach(([paramKey, paramValue]) => {
    const isRangeKey = isRangeSearchParam(paramKey);
    const isNumericKey = isNumericSearchParam(paramKey);

    if (!isFacetSearchParam(paramKey) && !isRangeKey && !isNumericKey) {
      return;
    }

    if (isRangeKey) {
      // Remove suffixes for range values
      paramKey = paramKey.replace(/(\|\w*)(__start$|__end$)/, '');
      paramValue = paramValue.replaceAll('-', '');
    }

    if (isArray(paramValue)) {
      paramValue.forEach((option) => {
        fetchSearchParams.append(paramKey, option);
      });
    } else {
      fetchSearchParams.set(paramKey, paramValue);
    }
  });

  const response = await fetch(url.href);
  const data = await response.json();
  return data;
};

export default fetchData;
